import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinkMe = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "20px",
	height: "10px",
	viewBox: "0 0 20 10",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Shape" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Wireframes-Web-Customer-Yulia",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Desktop---Dark---Customer---Link",
				transform: "translate(-998.000000, -316.000000)",
				fill: "#FFEDBA",
				fillRule: "nonzero",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M999.9,321 C999.9,319.29 1001.29,317.9 1003,317.9 L1007,317.9 L1007,316 L1003,316 C1000.24,316 998,318.24 998,321 C998,323.76 1000.24,326 1003,326 L1007,326 L1007,324.1 L1003,324.1 C1001.29,324.1 999.9,322.71 999.9,321 Z M1004,322 L1012,322 L1012,320 L1004,320 L1004,322 Z M1013,316 L1009,316 L1009,317.9 L1013,317.9 C1014.71,317.9 1016.1,319.29 1016.1,321 C1016.1,322.71 1014.71,324.1 1013,324.1 L1009,324.1 L1009,326 L1013,326 C1015.76,326 1018,323.76 1018,321 C1018,318.24 1015.76,316 1013,316 Z",
					id: "Shape"
				})
			})
		})
	]
});
export default SvgLinkMe;
